export default __webpack_public_path__ + "static/media/developers.73895a05.svg";